import { useTranslation } from 'react-i18next'
import { useDocumentTitle } from '@/lib/seo'
import { SOFT_LAUNCH } from '@/lib/launchMode'
import { Hero } from '@/sections/Hero'
import { Pinned } from '@/sections/Pinned'
import { FeatureAutoRelationships } from '@/sections/FeatureAutoRelationships'
import { FeatureZeroShotAgentic } from '@/sections/FeatureZeroShotAgentic'
import { FeatureLineage } from '@/sections/FeatureLineage'
import { FeatureTokenAnonymization } from '@/sections/FeatureTokenAnonymization'
import { HowItWorks } from '@/sections/HowItWorks'
import { LiveDemoLoop } from '@/sections/LiveDemoLoop'
import { UseCases } from '@/sections/UseCases'
import { TrustStrip } from '@/sections/TrustStrip'
import { LatestNews } from '@/sections/LatestNews'
import { FAQ } from '@/sections/FAQ'
import { EarlyAccessCta } from '@/sections/EarlyAccessCta'
import { ScrollProgressLine } from '@/components/ScrollProgressLine'

export default function Home() {
  const { t } = useTranslation()
  useDocumentTitle(t('site.brandLong'))

  return (
    <div className="relative isolate">
      <ScrollProgressLine />
      <Hero />
      <Pinned />
      <FeatureAutoRelationships />
      <FeatureZeroShotAgentic />
      <FeatureLineage />
      <FeatureTokenAnonymization />
      <HowItWorks />
      <LiveDemoLoop />
      <UseCases />
      <TrustStrip />
      {!SOFT_LAUNCH && <LatestNews />}
      <FAQ />
      <EarlyAccessCta />
    </div>
  )
}
